import jwtDecode from 'jwt-decode';

import {
  ANONYMOUS_USER_STORAGE_ID,
  COLUMN_PREFERENCES_NAMESPACE,
  IColumnPreferenceScope,
  STORAGE_KEY_PREFIX,
} from '~/constants/storageKeys';
import { useTokenStore } from '~/store/modules/token/useTokenStore';

type IAccessData = {
  veiling_claim_type_identifier: string;
};

const getUserStorageId = (): string => {
  const accessToken = useTokenStore.getAccess();
  if (!accessToken) return ANONYMOUS_USER_STORAGE_ID;

  try {
    const accessData = jwtDecode<IAccessData>(accessToken);
    return accessData.veiling_claim_type_identifier || ANONYMOUS_USER_STORAGE_ID;
  } catch {
    return ANONYMOUS_USER_STORAGE_ID;
  }
};

const buildStorageKey = (scope: IColumnPreferenceScope): string =>
  `${STORAGE_KEY_PREFIX}:${COLUMN_PREFERENCES_NAMESPACE}:${getUserStorageId()}:${scope}`;

const readHiddenColumnKeys = (scope: IColumnPreferenceScope): string[] => {
  try {
    const stored = localStorage.getItem(buildStorageKey(scope));
    if (!stored) return [];

    const parsed: unknown = JSON.parse(stored);
    if (!Array.isArray(parsed)) return [];

    return parsed.filter((key): key is string => typeof key === 'string');
  } catch {
    return [];
  }
};

export const getVisibleColumnKeys = (
  scope: IColumnPreferenceScope,
  allColumnKeys: readonly string[],
): string[] => {
  const hiddenKeys = readHiddenColumnKeys(scope);
  if (!hiddenKeys.length) return [...allColumnKeys];

  return allColumnKeys.filter(key => !hiddenKeys.includes(key));
};

export const saveVisibleColumnKeys = (
  scope: IColumnPreferenceScope,
  allColumnKeys: readonly string[],
  visibleColumnKeys: string[],
): void => {
  const hiddenKeys = allColumnKeys.filter(key => !visibleColumnKeys.includes(key));

  try {
    localStorage.setItem(buildStorageKey(scope), JSON.stringify(hiddenKeys));
  } catch (error) {
    console.error('Não foi possível salvar a preferência de colunas:', error);
  }
};

export const clearColumnPreferences = (scope: IColumnPreferenceScope): void => {
  try {
    localStorage.removeItem(buildStorageKey(scope));
  } catch (error) {
    console.error('Não foi possível limpar a preferência de colunas:', error);
  }
};
